import React from 'react';
import { ConfirmModal } from './ui.jsx';

export default function DeleteCalendarModal({ open, busy, onClose, onConfirm }) {
  return (
    <ConfirmModal
      open={open}
      busy={busy}
      title="Reset Calendar Settings?"
      confirmLabel={busy ? 'Resetting…' : 'Delete & Reset'}
      onCancel={onClose}
      onConfirm={onConfirm}
    >
      Are you sure you want to delete this calendar setup? All custom titles, instructions,
      availability rules, and appearance colors will be restored to defaults.
    </ConfirmModal>
  );
}
